
import { useMediaQuery } from 'react-responsive';
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import { isDesktopMediaQuery } from '../constants/constants';
import Skeleton from 'react-loading-skeleton';
const DMAutomationsSkeleton = () => {
    const isDesktop = useMediaQuery(isDesktopMediaQuery);
    return (
        <div className='mt-4 mb-4'>
            <h4 className="pop mx-3 mb-3"><Skeleton width={250} /></h4>
            <Swiper className="mySwiper mt-2 px-2"
                slidesPerView={isDesktop ? 2.2 : 1.2}
                spaceBetween={10}
                freeMode={true}
            >
                {
                    Array.from({ length: 3 }).map((_, i) => {
                        return (
                            <SwiperSlide key={i}>
                                <div className="card card-style m-0 mx-1 shadow-none border p-3 position-relative">
                                    <div className='position-relative'>
                                        <Skeleton className='post-thumbnail rounded-4' />
                                        <div className="card-body text-start p-0 mt-2">
                                            <Skeleton height={20} />
                                            <Skeleton height={50} />
                                        </div>
                                        <Skeleton height={50} className='btn btn-sm rounded-sm mt-2' />
                                    </div>

                                </div>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </div>
    )
}

export default DMAutomationsSkeleton